import { reactive } from 'vue'

export const state = reactive({
  userAuthenticated: false,
  dictionary: {},
  questions: [],
  questionsHeader: '',
  benefitsTitle: null,
  memberBenefitsTitle: null,
  generalBenefitsTitle: null,
  memberBenefits: [],
  generalBenefits: [],
  juraMailActive: false,
  currentPage: 0,
  answers: {
    'Salary.Questions.HighestEducation': null,
    'Salary.Questions.YourAge': null,
    'Salary.Questions.Sector': null,
    'Salary.Questions.WorkArea': null,
    'Salary.Questions.WorkFunction': null,
    'Salary.Questions.Leadership': null,
    'Salary.Questions.Region': null,
    'Salary.Questions.HoursAWeek': null,
  },
  displayAnswers: {
    'Salary.Questions.HighestEducation': null,
    'Salary.Questions.YourAge': null,
    'Salary.Questions.Sector': null,
    'Salary.Questions.WorkArea': null,
    'Salary.Questions.WorkFunction': null,
    'Salary.Questions.Leadership': null,
    'Salary.Questions.Region': null,
    'Salary.Questions.HoursAWeek': null,
  },
  leadData: null,
  listKeys: {
    'Salary.Questions.HighestEducation': 'education',
    'Salary.Questions.Sector': 'sector',
    'Salary.Questions.WorkArea': 'workareas',
    'Salary.Questions.WorkFunction': 'position', // nested in workareas-object
    'Salary.Questions.Leadership': 'personelResponsibility',
    'Salary.Questions.Region': 'region',
    'Salary.Questions.HoursAWeek': 'weeklyHours',
    'Salary.Questions.YourAge': 'age',
  },
  questionTypeToRawComponent: {
    // TODO: move to mappings and rename (used in QuestionPage.vue)
    'Highest Education': 'DropDown',
    Sector: 'DropDown',
    'Primary Area': 'DropDown',
    'Primary Function': 'DropDown',
    Leadership: 'DropDown',
    Region: 'DropDown',
  },
  user: {
    isMember: false,
    memberId: '',
    privateEmail: {
      email: '',
      primary: false
    },
    workEmail: {
      email: '',
      primary: false
    },
    firstName: '',
    memberData: {
      'Salary.Questions.HighestEducation': null,
      'Salary.Questions.YourAge': null,
      'Salary.Questions.Sector': null,
      'Salary.Questions.WorkArea': null,
      'Salary.Questions.WorkFunction': null,
      'Salary.Questions.Leadership': null,
      'Salary.Questions.Region': null,
      'Salary.Questions.HoursAWeek': null,
    },
  },
  lists: null,
  resultTypicalSalaryTitle: '',
  resultBenefitsTitle: '',
  resultGeographyTitle: '',
  resultLinks: [],
  resultLinksNonMember: [],
  salarySliderLabelQ1: '',
  salarySliderLabelQ2: '',
  salarySliderLabelQ3: '',
  salarySliderLabelQ4: '',
  resultData: null,
  salarySliderIndex: 1,
  culture: 'da-DK',
  isIntroPageMounted: false,
  isSubmitting: false,
  selectedWorkAreas: []
})

export function localDictionary() {
  if (!state.dictionary.languages) {
    return []
  }

  const languageData = state.dictionary.languages.find((f) => f.language === state.culture)

  return languageData ? languageData.items : []
}

export const getCalculatedSalaryEstimatePayload = () => {
  const answers = state.answers

  // Extract only the numeric part of memberId by removing "mitid\\" prefix if present
  let memberNo = null
  if (state.user.isMember && state.user.memberId && typeof state.user.memberId === 'string') {
    memberNo = state.user.memberId.replace(/^mitid\\/, '')
  }

  const payload = {
    education: answers['Salary.Questions.HighestEducation'],
    position: answers['Salary.Questions.WorkFunction'],
    age: answers['Salary.Questions.YourAge'],
    weeklyHours: answers['Salary.Questions.HoursAWeek'],
    sector: answers['Salary.Questions.Sector'],
    region: answers['Salary.Questions.Region'],
    personelResponsibility: answers['Salary.Questions.Leadership'],
    memberNo: memberNo,
  }

  if (!state.user.isMember && state.leadData) {
    payload.leadData = state.leadData
  }

  return payload
}
